<template lang="pug">
div
  button.change-button(
    :disabled="disabled || loading"
    v-if="showButton"
    @click="show = true"
    data-testid="action-btn-revisar-rechazo"
  )
    b-spinner(v-if="loading" small)
    span(v-else) Revisar Rechazo
  b-modal(
    v-model="show"
    size="lg"
    title="Revisar Rechazo"
    id="modal-revisar-rechazo"
    hide-footer
    no-enforce-focus
  )
    .mb-2
      .row.mb-2
        .col-6
          span.font-weight-bold N° de Serie:
          |  {{ (ot.equipo && ot.equipo.serial_number) || '—' }}
        .col-6
          span.font-weight-bold RMA:
          |  {{ ot.rma || '—' }}
      .row.mb-3
        .col-6
          span.font-weight-bold Modelo:
          |  {{ (ot.equipo && ot.equipo.modelo_detail && ot.equipo.modelo_detail.model_name) || '—' }}
        .col-6
          span.font-weight-bold Falla reportada:
          |  {{ ot.reporte_falla_cliente || '—' }}
    b-form-group
      template(#label)
        span.font-weight-bold Diagnóstico:
      p.mb-0 {{ ot.diagnostico_detail && ot.diagnostico_detail.informe }}
    b-form-group
      template(#label)
        span.font-weight-bold Motivo de rechazo:
      b-form-textarea(v-model="form.comentario_rechazo" rows="4")
    div.d-flex.justify-content-between.w-100.pt-2.pb-3
      b-button.btn-samtek-secondary(
        size="sm"
        variant="light"
        @click="show = false"
        :disabled="loading"
      ) Cancelar
      div
        b-button.btn-samtek-secondary.mr-2(
          size="sm"
          variant="light"
          @click="rechazar"
          :disabled="loading"
          data-testid="modal-reject-revisar-rechazo"
        ) Rechazar
        b-button.btn-samtek-primary(
          size="sm"
          @click="aprobar"
          :disabled="loading"
          data-testid="modal-approve-revisar-rechazo"
        ) Aprobar
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

export default {
  name: 'ActionRevisarRechazo',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],
  data() {
    return {
      show: false,
      showButton: true,
      form: {
        comentario_rechazo: this.ot?.diagnostico_detail?.comentario_rechazo || '',
      },
    }
  },
  watch: {
    'ot.diagnostico_detail.comentario_rechazo': {
      immediate: true,
      handler(val) {
        this.form.comentario_rechazo = val || ''
      },
    },
  },
  computed: {
    ...mapGetters('AuthenticationStore', ['user']),
  },
  methods: {
    ...mapActions('OTStore', ['revisarRechazo', 'getOT']),
    async aprobar() {
      try {
        await this.executeWithLoading(async () => {
          // El motivo de rechazo es lo que verá el cliente una vez aprobado,
          // así que se guarda antes de dejar el rechazo firme.
          if (
            this.form.comentario_rechazo !==
            this.ot.diagnostico_detail?.comentario_rechazo
          ) {
            await this.$store.dispatch('Diagnosticos/updateDiagnoseOT', {
              id: this.ot.diagnostico_detail.id,
              comentario_rechazo: this.form.comentario_rechazo,
              orden_trabajo: this.ot.ot,
            })
          }

          await this.revisarRechazo({ otId: this.ot.ot, aprobado: true })
          this.$bvToast.toast('Rechazo aprobado.', { variant: 'success' })
          await this.getOT(this.ot.ot)
          this.$emit('changed')
          this.show = false
        })
      } catch (error) {
        console.error('Error al aprobar el rechazo:', error)
        this.$bvToast.toast('Error al aprobar el rechazo.', {
          variant: 'danger',
        })
      }
    },
    async rechazar() {
      try {
        const confirmed = await this.$bvModal.msgBoxConfirm(
          '¿Seguro deseas rechazar la revisión? La OT volverá al estado en que estaba antes de ser rechazada.',
          {
            title: 'Por favor Confirma',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'SÍ',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          }
        )
        if (!confirmed) return
        await this.executeWithLoading(async () => {
          await this.revisarRechazo({ otId: this.ot.ot, aprobado: false })
          this.$bvToast.toast('OT devuelta a su estado anterior.', {
            variant: 'success',
          })
          await this.getOT(this.ot.ot)
          this.$emit('changed')
          this.show = false
        })
      } catch (error) {
        console.error('Error al rechazar la revisión:', error)
        this.$bvToast.toast('Error al rechazar la revisión.', {
          variant: 'danger',
        })
      }
    },
  },
}
</script>
